import type { TrialStatus } from '../../../hooks/useTrialSystem';

interface TrialStatusBarProps {
  status: TrialStatus;
  onUpgrade: () => void;
}

export default function TrialStatusBar({ status, onUpgrade }: TrialStatusBarProps) {
  const { messagesRemainingToday, messagesLimitPerDay, currentDay, totalDays } = status;
  const usedToday = messagesLimitPerDay - messagesRemainingToday;
  const progressPercent = (usedToday / messagesLimitPerDay) * 100;

  const isLow = messagesRemainingToday <= 5 && messagesRemainingToday > 0;
  const isVeryLow = messagesRemainingToday <= 2 && messagesRemainingToday > 0;
  const isEmpty = messagesRemainingToday === 0;

  const barColor = isEmpty
    ? 'bg-red-400'
    : isVeryLow
    ? 'bg-orange-400'
    : isLow
    ? 'bg-yellow-400'
    : 'bg-[#06C755]';

  const textColor = isEmpty
    ? 'text-red-500'
    : isVeryLow
    ? 'text-orange-500'
    : isLow
    ? 'text-yellow-600'
    : 'text-gray-500';

  return (
    <div className="px-3 pt-1.5 pb-1">
      <div className="bg-white/35 backdrop-blur-md rounded-lg px-2.5 py-1 border border-white/35 shadow-sm flex items-center gap-2">
        {/* Day表示 */}
        <span className="text-[10px] text-gray-400 whitespace-nowrap flex-shrink-0">
          Day {currentDay}/{totalDays}
        </span>

        {/* プログレスバー */}
        <div className="flex-1 h-1 bg-white/30 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-500 ${barColor}`}
            style={{ width: `${progressPercent}%` }}
          />
        </div>

        {/* 残り回数 */}
        <span className={`text-[10px] font-semibold whitespace-nowrap flex-shrink-0 ${textColor}`}>
          残り{messagesRemainingToday}/{messagesLimitPerDay}
        </span>

        {/* アップグレードボタン（残り少ない時のみ） */}
        {(isLow || isEmpty) && (
          <button
            onClick={onUpgrade}
            className="text-[10px] text-[#06C755] font-bold hover:underline cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            無制限→
          </button>
        )}
      </div>
    </div>
  );
}
